import type { Site } from './sites';

/** Returns elastic search index for the SEARCH functionality. */
export const getElasticSearchAliasName = (
  site: Site,
  environmentId: string,
  isPreview: boolean,
  prefix?: string
): string => {
  const suffix = isPreview ? 'staging' : 'production';

  const baseName = `search_${site}_${environmentId}_${suffix}`;

  if (prefix) {
    return `${prefix}_${baseName}`;
  }

  return baseName;
};

/** Elastic Alias for the JOBS functionality */
export const elasticJobsAliasName = 'jobs_production';
/** Development Elastic Alias for the JOBS functionality */
export const elasticJobsAliasNameDev = 'dev_jobs';
/** Elastic index prefix for the jobs indexes. */
export const elasticJobsIndexPrefix = 'jobs_';

/** Returns elastic search index for the GALLERY functionality */
export const getElasticGalleryAliasName = (
  site: Site,
  environmentId: string,
  isPreview: boolean
): string => {
  const stagingOrProduction = isPreview ? 'staging' : 'production';
  return `gallery_${site}_${environmentId}_${stagingOrProduction}`;
};

/** V2 Serverless Elastic Staging Cloud ID (single source of truth for MWP packages). */
export const v2StagingElasticCloudId =
  'mwp-serverless-elastic-staging:dXMtY2VudHJhbDEuZ2NwLmVsYXN0aWMuY2xvdWQkZGU5Y2UwMGNkNjNjNDEwYjkxN2Q3YWQ4ZjJiMTlkY2YuZXMkZGU5Y2UwMGNkNjNjNDEwYjkxN2Q3YWQ4ZjJiMTlkY2Yua2I=';

/** V2 Serverless Elastic Production Cloud ID. */
export const v2ProductionElasticCloudId =
  'mwp-serverless-elastic-prod:dXMtY2VudHJhbDEuZ2NwLmVsYXN0aWMuY2xvdWQkYjM5N2NhYmFjNzNmNDNhOGE3YjZiZjRkZjU2MzgyZmYuZXMkYjM5N2NhYmFjNzNmNDNhOGE3YjZiZjRkZjU2MzgyZmYua2I=';

/** V2 Serverless Elastic Staging node URL. */
export const v2StagingElasticNode =
  'https://mwp-serverless-elastic-staging-de9ce0.es.us-central1.gcp.elastic.cloud:443';

/** V2 Serverless Elastic Production node URL. */
export const v2ProductionElasticNode =
  'https://mwp-serverless-elastic-prod-b397ca.es.us-central1.gcp.elastic.cloud:443';
